import { useEffect, useRef, useState } from "react";

const SESSION_KEY = "raijada_lead_popup_shown";

const isAnyDialogOpen = () => !!document.querySelector('[role="dialog"][data-state="open"]');

export const useLeadPopup = () => {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(false);
  const retryRef = useRef(null);

  const triggerOpen = () => {
    if (shownRef.current) return;
    if (isAnyDialogOpen()) {
      retryRef.current = setTimeout(triggerOpen, 3000);
      return;
    }
    shownRef.current = true;
    sessionStorage.setItem(SESSION_KEY, "1");
    setOpen(true);
  };

  const openManually = () => {
    shownRef.current = true;
    setOpen(true);
  };

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) {
      shownRef.current = true;
      return;
    }

    const timer = setTimeout(triggerOpen, 8000);

    const onScroll = () => {
      const scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (scrolled > 0.4) triggerOpen();
    };

    const onMouseLeave = (e) => {
      if (e.clientY <= 0) triggerOpen();
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("mouseout", onMouseLeave);

    return () => {
      clearTimeout(timer);
      clearTimeout(retryRef.current);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onMouseLeave);
    };
  }, []);

  return { open, setOpen, openManually };
};
